import { useStaticQuery, graphql } from 'gatsby'

export const useContactQuery = () => {
  const { wp, wpPage } = useStaticQuery(graphql`
    query ContactQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            callText
            phoneNumber
          }
        }
      }
      wpPage(title: { eq: "Home" }) {
        contact {
          contact {
            backgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            title
            text
            submitButtonText
            foregroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP)
                }
              }
            }
            foregroundImageAltText
          }
        }
      }
    }
  `)
  return { wp, wpPage }
}
